export default __webpack_public_path__ + "static/media/pizza-hut-new-vertical.ae473839.svg";